import { render, staticRenderFns } from "./bindingPhone.vue?vue&type=template&id=2a06c964&scoped=true&"
import script from "./bindingPhone.vue?vue&type=script&lang=js&"
export * from "./bindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindingPhone.vue?vue&type=style&index=0&id=2a06c964&lang=less&scoped=true&"
import style1 from "./bindingPhone.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06c964",
  null
  
)

export default component.exports